import React from 'react'

import { PageHeader, Table, Space, Button } from 'antd'
import { displayDate } from '../../../../../core/utils/date'
import { DownloadOutlined } from '@ant-design/icons'

const Tasks = (props) => {
  const columns = (props) => [
    {
      title: 'ID',
      dataIndex: 'display_id',
      key: 'display_id',
      width: 120,
      //render: (display_id, record) => <Link to={LAYOUT_FINANCE_PAYMENT_SHOW(record.id)}>{display_id}</Link>,
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date) => (date ? displayDate(date) : '-'),
      width: 120
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes'
    },
    {
      title: 'Amount',
      dataIndex: 'amount_value',
      key: 'amount_value',
      align: 'right',
      width: 200,
      render: (price, record) => (
        <>
          {price} {record.amount_type}
        </>
      )
    },
    {
      title: 'Action',
      key: 'operation',
      align: 'center',
      width: 100,
      render: (record) => {
        if (record.attachment && record.attachment?.name) {
          return (
            <Space>
              <Button
                style={{ margin: 0 }}
                icon={<DownloadOutlined />}
                size='small'
                onClick={() => props.onDownloadReceipt({id: record.id, name: record.attachment?.name})}
                disabled={props.actionLoading}
              />
            </Space>
          )
        }
      }
    }
  ]

  const payments = props.payments

  if ((payments || []).length === 0) {
    return null
  }

  const rowKey = (record) => record.id

  return (
    <PageHeader ghost={false} title='Payments'>
      <Table
        size='small'
        className='components-table-demo-nested'
        columns={columns(props)}
        rowKey={rowKey}
        dataSource={payments}
        pagination={false}
        bordered
      />
    </PageHeader>
  )
}

export default Tasks
